export const showMenu = state => state.mainMenu.show



// WEBPACK FOOTER //
// ./src/vuex/main-menu/getters.js